// @flow
import { ioc } from 'core/ioc'
import { SERVICES } from 'core/constants/services'
import type { HistoryService as HService } from './service'

const service: HService = ioc.container[SERVICES.HISTORY]
const history = service.getHistory()

export { history, service }

export * from './types'
